export { FeaturedProductsRenderer } from './FeaturedProductsRenderer'
export type { FeaturedProductsRendererProps } from './FeaturedProductsRenderer'
